import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api/chatbot`;

export const sendChatMessage = async (message, sessionId) =>
  (await axios.post(`${API}/message`, { message, sessionId })).data;

/**
 * Stream a reply via SSE. Calls onEvent({type, content|source|suggestedActions}) for each event.
 * Resolves when the stream closes. Throws on network / HTTP error.
 */
export const streamChatMessage = async (message, sessionId, onEvent) => {
  const res = await fetch(`${API}/message/stream`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ message, sessionId }),
  });
  if (!res.ok || !res.body) throw new Error(`Chat stream failed (${res.status})`);
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const events = buffer.split("\n\n");
    buffer = events.pop();
    for (const ev of events) {
      const line = ev.split("\n").find((l) => l.startsWith("data: "));
      if (line) onEvent(JSON.parse(line.slice(6)));
    }
  }
};

export const fetchQuickActions = async () =>
  (await axios.get(`${API}/quick-actions`)).data.actions;

export const checkApplication = async (reference, verifier) => {
  try {
    const { data } = await axios.post(`${API}/check-application`, { reference, verifier });
    return data;
  } catch (err) {
    const d = err?.response?.data;
    throw { message: d?.message || "Unable to verify your application.", errors: d?.errors || {} };
  }
};
